import {IconButton} from "@mui/material"
import {ReactNode, useState} from "react";
import {Close, InfoOutlined} from "@mui/icons-material";

export interface HintProps {
    message: ReactNode;
}

export default function Hint({message,}: HintProps) {
    const [showAlert, setShowAlert] = useState(true);
    return showAlert ? (
        <div className="bg-[#E8F0FF] flex items-center justify-between py-3 px-4 rounded-md my-2  mb-8">
            <div className="flex items-center gap-4">
                <span className="text-xs leading-6">
                    {message}
                </span>
            </div>
            <IconButton onClick={() => setShowAlert(false)} size="small">
                <Close fontSize="small"/>
            </IconButton>
        </div>
    ) : <></>
}
